<template>
  <van-tabbar :z-index="100" class="tab-bar no-bottom-tab" route>
    <van-tabbar-item to="/home" replace>
      <span>岗位</span>
      <img slot="icon" slot-scope="props" :src="props.active ? icon.active : icon.normal"/>
    </van-tabbar-item>
    <van-tabbar-item to="/team" replace>
      <span>团队</span>
      <img slot="icon" slot-scope="props" :src="props.active ? icon1.active : icon1.normal"/>
    </van-tabbar-item>
    <van-tabbar-item to="/my-bill" replace>
      <span>财富</span>
      <img slot="icon" slot-scope="props" :src="props.active ? icon2.active : icon2.normal"/>
    </van-tabbar-item>
    <van-tabbar-item to="/my-center" replace>
      <span>我的</span>
      <img slot="icon" slot-scope="props" :src="props.active ? icon3.active : icon3.normal"/>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
  export default {
    data() {
      return {
        active: '',
        icon: {
          normal: require('../../assets/images/common/home.png'),
          active: require('../../assets/images/common/home-on.png')
        },
        icon1: {
          normal: require('../../assets/images/common/group.png'),
          active: require('../../assets/images/common/group-on.png')
        },
        icon2: {
          normal: require('../../assets/images/common/wealth.png'),
          active: require('../../assets/images/common/wealth-on.png')
        },
        icon3: {
          normal: require('../../assets/images/common/my.png'),
          active: require('../../assets/images/common/my-on.png')
        }
      };
    },
    methods: {}
  };
</script>
<style lang="less">
.no-bottom-tab.van-hairline--top-bottom::after{border-bottom-width: 0;border-color:#ebedf0;}
</style>
